import { defineContract } from "../defineContract";

/**
 * Interruptor do cache de leitura do frontend.
 *
 * Válvula de escape, não configuração de produto: se o cache se comportar mal
 * em produção e ninguém souber ainda qual caminho de escrita esqueceu de
 * avisar, o suporte desliga tudo pelo `.env` e reinicia — sem deploy e sem
 * reverter código.
 */
export interface FrontendCacheConfig {
  enabled: boolean;
}

export const frontendCacheContract = defineContract<void, FrontendCacheConfig>({
  route: "/settings/frontend-cache",
  method: "GET"
  // Sem `cache` de propósito: este é o interruptor DO cache. Guardá-lo pelo
  // mesmo mecanismo que ele controla é a armadilha óbvia — desligado o cache,
  // a leitura do interruptor também deixaria de ser cacheada, e ligado ele
  // ficaria preso ao próprio TTL. Quem consome guarda em memória por conta
  // própria (ver services/cachedApi), e o custo é uma requisição por carga.
});
